import React from 'react'

export default props => (
        <div className="pull-left info">
            {props.children}            
        </div>
)